

import React,  { useState } from "react";
import { Typography, Box } from "@mui/material";
import FilterControlsPDPVCDP from "../components/FilterControlsPDPVCDP";
import PDPVCDPSupplyTable from "../components/PDPVCDPSupplyTable";


function PDPVCDP() {

  const [loading, setLoading] = useState(false);
const [pdpReportDatas, setPDPReportDatas] = useState([]);
const [vcdpReportDatas, setVCDPReportDatas] = useState([]);
const primaryColor = "#005EB8"; // Cognizant's primary blue
const handleReportData = (data) => {
    setPDPReportDatas(data.pdpResponseData);
    setVCDPReportDatas(data.vcdpResponseData)
  };
  
  const pdpTableNames = [
    'EI A+ PDP',
    'EI P* PDP',
    'DPO A+ PDP',
    'DPO P* PDP' 
    ];
    
    const vcdpTableNames = [
    'EI  A+ CDeploy',
    'EI  P* CDeploy',
    'DPO A+ CDeploy',
    'DPO P* CDeploy',
  ];

  
  return (
    <Box sx={{ width: "100%" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
          }}
        >
         <Typography
                     variant="h5"
                     sx={{
                       fontWeight: "bold",
                       color: primaryColor,
                       marginBottom: 2,
                       textAlign: "left",
                     }}
                   >
                    PDP & VCDP WoW Report
                   </Typography>

        </Box>
        <FilterControlsPDPVCDP onReportData={handleReportData} loading={loading} setLoading={setLoading} />

   

        {pdpReportDatas && !loading ? (
        <>
          <Box sx={{ display: "flex", flexWrap: "wrap" }}>
            {pdpReportDatas.map((pdpReportData, index) => (
              <Box key={pdpTableNames[index]} sx={{ width: "25%" }}>
                <PDPVCDPSupplyTable
                  reportData={pdpReportData}
                  tableName={pdpTableNames[index]}
                />
              </Box>
            ))}
          </Box>

          <Box sx={{ display: "flex", flexWrap: "wrap" }}>
            {vcdpReportDatas.map((vcdpReportData,index) => (
              <Box key={vcdpTableNames[index]} sx={{ width: "25%" }}>
                <PDPVCDPSupplyTable
                  reportData={vcdpReportData}
                  tableName={vcdpTableNames[index]}
                />
              </Box>
            ))}
          </Box>
        </>
      ): "Loading..." }
      </Box>
  );
}

export default PDPVCDP;